module.exports = function() {
  return new Worker(__webpack_public_path__ + "a617b35e73d50838ad30.worker.js");
};